import Konva from "konva";
import { TypeCanvasElement } from "shared/consts";
import { ElementDrawProps } from "shared/datamodel/canvas-element";

export enum MovingStatus {
  Beginning,
  Ongoing,
}

export interface MaybeMovingElements {
  kind: MovingStatus.Beginning;
  elementUnderMouse?: Konva.Node;
  ids: string[];
}

export interface ActuallyMovingElements {
  kind: MovingStatus.Ongoing;
  elementUnderMouse?: Konva.Node;
  nodes: Konva.Node[];
  ids: string[];
  stats: Record<TypeCanvasElement, number>;
  getInitialState: () => Map<string, ElementDrawProps>;
  getNewState: () => Map<string, ElementDrawProps>;
}

export type MovingElements = MaybeMovingElements | ActuallyMovingElements;
